































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import Dropdown from './Dropdown.vue'
import BaseButton from './BaseButton.vue'
import { Option, FilterRuleOperator } from '@/entities'
import FilterModalMobileHeader from '@/components/FilterModalMobileHeader.vue'
import SearchBox from '@/components/SearchBox.vue'

type OptionSetKey = 'general' | 'custom'

@Component<FilterBarNPSType>({
    components: {FilterModalMobileHeader, BaseButton, Dropdown, SearchBox }
})
export default class FilterBarNPSType extends Vue {

    @Getter public filterActive
    @Getter public filterRuleOptions
    @Getter public filterLoadingRuleSubOption
    @Getter public filterActiveRuleSubOption
    @Getter public filterActiveRuleSubOptions
    @Getter public filterSearchTerm
    @Getter public filterPatching
    @Getter public tsMobileView
    @Getter
    hasNetworkConnection!:boolean

    @Action public getRuleOptions
    @Action public loadRuleSubOptions
    @Action public reloadRuleSubOptions
    @Action public clearRuleSubOption
    @Action public setFilterRule
    @Action public setSearchTerm

    public selectedSubOptions: Array<Option<string>> = []
    public mode: 'single' | 'multi' = 'single'
    public showFilterRuleOperatorOptions = false

    public strOperators: FilterRuleOperator[] = [
        {
            name: 'is',
            operator: 'in'
        }, {
            name: 'is not',
            operator: 'notin'
        }
    ]

    public strOperatorExclude = ['comments', 'notes', 'messaged', 'published', 'case']

    // numeric operators
    public operators: FilterRuleOperator[] = [{
        name: 'is  ',
        operator: 'in'
    }, {
        name: 'is not  ',
        operator: 'notin'
    }, {
        name: 'Greater than  ',
        operator: 'gt'
    }, {
        name: 'Less than  ',
        operator: 'lt'
    }]
    public filterRuleOperator: FilterRuleOperator = this.operators[0]
    public subOption?: string
    public optionSetKey?: OptionSetKey
    public filterSubOptionValue = ''
    public delayTimer // a delaytime to delay search ajax request

    public get showSubOptions(): boolean {
        const { filterLoadingRuleSubOption, filterActiveRuleSubOption } = this
        return !filterLoadingRuleSubOption && filterActiveRuleSubOption
    }

    public get applyingLabel() {
        return this.filterPatching ? 'Applying...' : 'Apply'
    }

    public get filterIsNumeric() {
        return this.filterActiveRuleSubOptions &&
            this.filterActiveRuleSubOptions.some((element) => !isNaN(element.value))
    }

    public get currentOperators(): FilterRuleOperator[] {
        return this.filterIsNumeric ? this.operators : this.strOperators
    }

    public get activeRuleOptionLabel() {
        if (!this.filterActiveRuleSubOption || !this.$store.state.filter.ruleOptions || this.$store.state.filter.ruleOptions.length === 0) {
            return ''
        }

        const activeRuleOption = this.$store.state.filter.ruleOptions.find((ruleOption) => ruleOption.value === this.filterActiveRuleSubOption)

        return activeRuleOption?.label ?? ''
    }

    public results(searchTerm: string, options: Array<Option<string>>) {
        const filtered = searchTerm.length > 0 ?
            options.filter((opt) => String(opt.label).toLowerCase().trim().indexOf(searchTerm) > -1) :
            options
        return filtered.slice(0, 5)
    }

    public mounted() {
        this.getRuleOptions()
        if (this.filterActiveRuleSubOption) {
            this.loadRuleSubOptions(this.filterActiveRuleSubOption)
        }
    }

    public async initSubOptions(subOption: string, optionSetKey: OptionSetKey) {
        this.subOption = subOption
        this.optionSetKey = optionSetKey
        this.mode = optionSetKey === 'general' ? 'single' : 'multi' // custom fields allow multiple values
        this.mode = subOption === 'tag' ? 'multi' : this.mode // enable multi hashtag search
        await this.loadRuleSubOptions(subOption)
        this.filterRuleOperator = this.currentOperators[0]
        await this.refreshSubOptions()
        const optionSet = document.getElementById('sub-options')
        if (optionSet !== null) {
            optionSet.scrollIntoView()
        }
    }

    public refreshSubOptions() {
        const activeRule = this.filterActive.filter_rules.find(
            (rule) => rule.column === this.subOption && rule.operator === this.filterRuleOperator.operator
        )

        if (activeRule) {
            this.filterRuleOperator = this.currentOperators.find(
                (o: FilterRuleOperator) => o.operator === activeRule.operator
            ) || this.filterRuleOperator
        }

        if (activeRule && this.mode === 'multi') {
            this.selectedSubOptions = activeRule.value.map((value) => ({ value, label : value }))
        }

        if (this.filterIsNumeric && !activeRule) {
            this.selectedSubOptions = []
        }

        this.filterSubOptionValue = this.getSelectedSubOptionValue()
    }

    public clearSelectedSubOptions(): void {
        this.selectedSubOptions = []
        this.clearRuleSubOption()
        this.showFilterRuleOperatorOptions = false
    }

    public getSelectedSubOptions() {
        return this.selectedSubOptions
    }

    public getOptionValueLabel(opt) {
        const found = this.filterActiveRuleSubOptions.find((ruleOption) => ruleOption.value === opt.value)
        return found ? found.label : opt.label
    }

    public getSelectedSubOptionValue() {
        const option = this.getSelectedSubOptions()[0]
        return option && option.value || ''
    }

    public addToSelectedSubOptions(selectedSubOption: Option<string>): void {
        if (!this.selectedSubOptions.some((element) => element.value === selectedSubOption.value)) {
            this.selectedSubOptions.push(selectedSubOption)
        }
    }

    public removeFromSelectedSubOptions(subOptionToRemove: Option<string>): void {
        this.selectedSubOptions = this.selectedSubOptions.filter((element) =>
            element.value !== subOptionToRemove.value
        )
    }

    public handleFilterRuleOperatorOptions(): void {
        this.showFilterRuleOperatorOptions = !this.showFilterRuleOperatorOptions
    }

    public handleSelectOperator(operator: FilterRuleOperator): void {
        this.filterRuleOperator = operator
        this.showFilterRuleOperatorOptions = false
        this.refreshSubOptions()
    }

    public async handleClickOption(option: Option<string>) {
        if (!isNaN(option.value as any) && this.filterRuleOperator.operator !== 'in' &&
            this.filterRuleOperator.operator !== 'notin') {
            this.mode = 'single'
        }
        if (this.mode === 'multi') {
            this.addToSelectedSubOptions({
                value: option.value,
                label: option.label
            })
        } else {
            await this.setFilterRule({
                id: this.filterActive.id,
                rule: {
                    column: this.filterActiveRuleSubOption,
                    operator: this.filterRuleOperator.operator,
                    value: [option.value]
                }
            })
            setTimeout(() => (this.$refs.dropdown as any).$data.opened = false, 0)
        }
    }

    private closeModal() {
        (this.$refs.dropdown as any).$data.opened = false
    }

    public async saveMultiFilter() {
        if (this.filterRuleOperator.operator !== 'in' && this.filterRuleOperator.operator !== 'notin'
            && !this.filterSubOptionValue) {
            return
        }
        await this.setFilterRule({
            id: this.filterActive.id,
            rule: {
                column: this.filterActiveRuleSubOption,
                operator: this.filterRuleOperator.operator,
                value: this.filterRuleOperator.operator === 'in' || this.filterRuleOperator.operator === 'notin' ?
                    this.selectedSubOptions.map(({value}) => value) :
                    [this.filterSubOptionValue]
            }
        })
        setTimeout(() => (this.$refs.dropdown as any).$data.opened = false, 0)

        this.clearSelectedSubOptions()
    }

    public onSearchInput(value) {
        this.setSearchTerm(value)
        clearTimeout(this.delayTimer)
        this.delayTimer = setTimeout(() => {
            this.reloadRuleSubOptions(this.filterActiveRuleSubOption)
        }, 300)
    }
}
